"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayFieldItemTemplate = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = require("./styled");
const components_1 = require("../../components");
const ArrayFieldItemTemplate = ({ children, className, disabled, hasMoveDown, hasMoveUp, hasRemove, index, onReorderClick, readonly, registry, onDropIndexClick, uiSchema }) => {
    const { MoveDownButton, MoveUpButton, RemoveButton } = registry.templates.ButtonTemplates;
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const showMoveUp = hasMoveUp || hasMoveDown;
    const showMoveDown = hasMoveUp || hasMoveDown;
    const showRemove = hasRemove;
    const removeBtnRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.Item, { className: `form-group field ${className !== null && className !== void 0 ? className : ''}` },
            react_1.default.createElement(styled_1.Header, null,
                react_1.default.createElement(styled_1.HeaderContent, null),
                react_1.default.createElement(styled_1.ItemButtons, null,
                    showMoveUp && (react_1.default.createElement(MoveUpButton, { disabled: disabled || readonly || !hasMoveUp, onClick: onReorderClick(index, index - 1), uiSchema: uiSchema, registry: registry })),
                    showMoveDown && (react_1.default.createElement(MoveDownButton, { disabled: disabled || readonly || !hasMoveDown, onClick: onReorderClick(index, index + 1), uiSchema: uiSchema, registry: registry })),
                    showRemove && (react_1.default.createElement("div", { ref: removeBtnRef },
                        react_1.default.createElement(RemoveButton, { disabled: disabled || readonly, onClick: () => setShowTooltip(true), uiSchema: uiSchema, registry: registry }))))),
            react_1.default.createElement(styled_1.Content, null, children)),
        react_1.default.createElement(components_1.StyledTooltip, { key: String(showTooltip), anchorEl: removeBtnRef.current, onClickOutside: () => setShowTooltip(false), isOpen: showTooltip },
            react_1.default.createElement(components_1.DeleteTooltip, { onDelete: onDropIndexClick(index), onClose: () => setShowTooltip(false) }))));
};
exports.ArrayFieldItemTemplate = ArrayFieldItemTemplate;
//# sourceMappingURL=array-field-item-template.js.map